import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from './layout';
import Login from './pages/Login';
import Ingredient from './pages/Ingredient';
import Manufacturer from './pages/Manufacturer';
import Tradename from './pages/Tradename';
import { DialogProvider } from './context/DialogContext';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <DialogProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/ingredients" replace />} />
            <Route path='/ingredients' element={<Ingredient />} />
            <Route path='/manufacturers' element={<Manufacturer />} />
            <Route path='/tradenames' element={<Tradename />} />
          </Route>
        </Routes>
        <ToastContainer />
      </DialogProvider>
    </BrowserRouter>
  );
}

